const contrastingColourList = [
    "#000",
    "#FFF",
];

export { contrastingColourList };
